module.exports = __webpack_public_path__ + "static/media/treeWithoutLeaf.2510dde4.png";